import { getPersistentItem, setPersistentItem, removePersistentItem } from './storage';

const KEY = 'session_v1';
export function readSession() {
    try {
        const session = JSON.parse(getPersistentItem(KEY));
        return /^aleta1_[\w-]{43}$/.test(session?.token) && Number.isSafeInteger(session?.actor?.userId) ? session : null;
    } catch { return null; }
}
export const saveSession = session => setPersistentItem(KEY, JSON.stringify(session));
export const clearSession = () => removePersistentItem(KEY);
export const getSessionToken = () => readSession()?.token || '';
export const sessionHeaders = () => {
    const token = getSessionToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
};
